export class Theme {
  primaryColor: string;
  secondaryColor: string;
  btnFontSize: string;
  titleFontSize: string;
  infoPanelFontSize: string;
  contentFontSize: string;

  constructor(
    primaryColor: string,
    secondaryColor: string,
    btnFontSize: string,
    titleFontSize: string,
    infoPanelFontSize: string,
    contentFontSize: string
  ) {
    this.primaryColor = primaryColor;
    this.secondaryColor = secondaryColor;
    this.btnFontSize = btnFontSize;
    this.titleFontSize = titleFontSize;
    this.infoPanelFontSize = infoPanelFontSize;
    this.contentFontSize = contentFontSize;
  }

  get btnFontSizeX2() {
    return this.calculateFontSizeX2Value(this.btnFontSize);
  }

  get titleFontSizeX2() {
    return this.calculateFontSizeX2Value(this.titleFontSize);
  }

  private calculateFontSizeX2Value(size: string) {
    const fontValue = parseFloat(size.substring(0, size.length - 2));
    const fontModifier = size.substring(size.length - 2);
    const fontValuePercentage = (50 * fontValue) / 100;
    const fontCalulated = (fontValue + fontValuePercentage).toFixed(1);
    return `${fontCalulated}${fontModifier} !important`;
  }

  static toEntity(data: Partial<Theme>) {
    return new Theme(
      data.primaryColor!,
      data.secondaryColor!,
      data.btnFontSize!,
      data.titleFontSize!,
      data.infoPanelFontSize!,
      data.contentFontSize!
    );
  }
}

export enum ThemeSlugs {
  PRIMARY_COLOR = '#fa0505 !important; /*primary*/',
  SECONDARY_COLOR = '#042443 !important; /*secondary*/',
  BTN_FONT_SIZE = '1rem !important; /*btnFontSize*/',
  BTN_FONT_SIZE_X2 = '20px !important; /*btnFontSizeX2*/',
  TITLE_FONT_SIZE = '20px !important; /*titleFontSize*/',
  TITLE_FONT_SIZE_X2 = '20px !important; /*titleFontSizeX2*/',
  INFO_PANEL_FONT_SIZE = '1rem !important; /*infoPanelFontSize*/',
  CONTENT_FONT_SIZE = '14px !important; /*content*/',
}

export enum ThemeDefaults {
  PRIMARY_COLOR = '#fa0505',
  SECONDARY_COLOR = '#042443',
}
